import {
  SnippetElement,
  defineElement,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/snippets/common-language-accordion/common-language-accordion.ts
var CommonLanguageAccordion = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  toggleButton() {
    if (this.isOpen) {
      this.closeModal();
    } else {
      this.openModal();
    }
  }
  openModal() {
    return __async(this, null, function* () {
      var _a, _b;
      this.isOpen = true;
      (_a = this.accordionButtonIcon) == null ? void 0 : _a.classList.remove("rotate-180");
      (_b = this.accordion) == null ? void 0 : _b.open();
    });
  }
  closeModal() {
    return __async(this, null, function* () {
      var _a, _b;
      this.isOpen = false;
      (_a = this.accordionButtonIcon) == null ? void 0 : _a.classList.add("rotate-180");
      (_b = this.accordion) == null ? void 0 : _b.close();
    });
  }
  onItemClick(elm) {
    var _a;
    this.inputLanguageCode.value = (_a = elm.dataset.value) != null ? _a : "";
    if (this.form) {
      this.form.submit();
    } else {
      console.log("failed to submit language form");
    }
  }
};
__decorateClass([
  query("[data-input-language-code]")
], CommonLanguageAccordion.prototype, "inputLanguageCode", 2);
__decorateClass([
  query("[data-button]")
], CommonLanguageAccordion.prototype, "buttons", 2);
__decorateClass([
  query("form")
], CommonLanguageAccordion.prototype, "form", 2);
__decorateClass([
  query("[data-accordion-button]")
], CommonLanguageAccordion.prototype, "accordionButton", 2);
__decorateClass([
  query("[data-accordion-button-icon]")
], CommonLanguageAccordion.prototype, "accordionButtonIcon", 2);
__decorateClass([
  query("[data-accordion]")
], CommonLanguageAccordion.prototype, "accordion", 2);
__decorateClass([
  onClick("[data-accordion-button]")
], CommonLanguageAccordion.prototype, "toggleButton", 1);
__decorateClass([
  onClick("[data-button]")
], CommonLanguageAccordion.prototype, "onItemClick", 1);
CommonLanguageAccordion = __decorateClass([
  defineElement("common-language-accordion")
], CommonLanguageAccordion);
export {
  CommonLanguageAccordion
};
